// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1xWVv","disabled":"FileBtn_disabled__1WOHx","warn":"FileBtn_warn__Gx4P9","fade":"FileBtn_fade__3IXo9"};